// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard_section {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 53px 26px;
    box-sizing: border-box;
}

.dashboard_section__inner {
    width: 100%;
    max-width: 528px;
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.dashboard_section__title {
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--color-text-muted);
}

.dashboard_section__empty {
    font-size: 14px;
    color: var(--color-text-muted);
}

.dashboard_section__list {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.dashboard_section__project {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 11px 15px;
    background-color: var(--color-bg-2);
    border: 1px solid var(--color-border);
    border-radius: 4px;
    cursor: pointer;
    text-align: left;
    transition: background-color 0.1s, border-color 0.1s;
}

@media (pointer: fine) {
    .dashboard_section__project:hover {
        background-color: var(--color-bg-3);
        border-color: var(--color-accent);
    }
}

.dashboard_section__project_name {
    font-size: 14px;
    color: var(--color-text);
}

.dashboard_section__file_browser {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 9px;
}

.dashboard_section__file_browser_list {
    max-height: 308px;
    overflow-y: auto;
}

.dashboard_section__open_project_btn {
    width: 100%;
    padding: 9px 15px;
    background-color: var(--color-accent);
    color: #fff;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    transition: background-color 0.1s;
}

@media (pointer: fine) {
    .dashboard_section__open_project_btn:hover {
        background-color: var(--color-accent-hover);
    }
}
`, "",{"version":3,"sources":["webpack://./components/sections/DashboardSection/s.dashboard_section.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,mCAAmC;IACnC,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oDAAoD;AACxD;;AAEA;IACI;QACI,mCAAmC;QACnC,iCAAiC;IACrC;AACJ;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,qCAAqC;IACrC,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI;QACI,2CAA2C;IAC/C;AACJ","sourcesContent":[".dashboard_section {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    padding: 53px 26px;\n    box-sizing: border-box;\n}\n\n.dashboard_section__inner {\n    width: 100%;\n    max-width: 528px;\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n}\n\n.dashboard_section__title {\n    font-size: 14px;\n    font-weight: 600;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: var(--color-text-muted);\n}\n\n.dashboard_section__empty {\n    font-size: 14px;\n    color: var(--color-text-muted);\n}\n\n.dashboard_section__list {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.dashboard_section__project {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    padding: 11px 15px;\n    background-color: var(--color-bg-2);\n    border: 1px solid var(--color-border);\n    border-radius: 4px;\n    cursor: pointer;\n    text-align: left;\n    transition: background-color 0.1s, border-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .dashboard_section__project:hover {\n        background-color: var(--color-bg-3);\n        border-color: var(--color-accent);\n    }\n}\n\n.dashboard_section__project_name {\n    font-size: 14px;\n    color: var(--color-text);\n}\n\n.dashboard_section__file_browser {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 9px;\n}\n\n.dashboard_section__file_browser_list {\n    max-height: 308px;\n    overflow-y: auto;\n}\n\n.dashboard_section__open_project_btn {\n    width: 100%;\n    padding: 9px 15px;\n    background-color: var(--color-accent);\n    color: #fff;\n    border-radius: 4px;\n    font-size: 14px;\n    font-weight: 500;\n    text-align: center;\n    transition: background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .dashboard_section__open_project_btn:hover {\n        background-color: var(--color-accent-hover);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
